const Routes = {
    TRAVELLER: "/traveller",
};

export default Routes;
